<template>
    <div class="event-container">
        <div class="center">
          <p :display="!displayLoading" class="oeticket-info" v-html="$t('events.places')"></p>
        </div>
        <loader :display="displayLoading"></loader>
        <div v-if="events.length == 0 && !error" class="center filler">
          <span v-html="$t('events.planning')"></span><br> <a href="mailto:info@ruth-musical.org">info@ruth-musical.org</a>
        </div>
        <div class="events">
          <div v-for="event in events" :class="{event: true, 'choose-place': event.PlaceCards}">
            <div class="inner-container">
              <div class="column information">
                  <div class="column time">
                      <span class="bold">{{event.DateTime.format($t("main.date-format"))}}</span>
                      <span>{{event.DateTime.format($t("main.time-format"))}} {{$t("events.time-postfix")}}</span>
                  </div>
                  <div class="column flex-1 musical">
                      <span class="bold">Ruth</span>
                      <span class="description">{{$t("events." + event.Type.replace(" ", "-"))}}</span>
                      <span class="extra-wrapper">
                        <span class="extra" v-if="event.Type == 'Das Konzert'">{{$t("events.concert")}}</span>
                      </span>
                  </div>
                  <div class="column flex-1 location">
                      <span class="bold">{{event.City}}</span>
                      <span>{{event.Country}}<span v-if="event.Country && event.State">,</span> {{event.State}}</span>
                  </div>
              </div>
              <div class="column ticket">
                <span :class="{button: true, 'sold-out': event.SoldOut}">
                  <router-link :to="getLink(event)" v-if="!event.SoldOut && !event.SellLink && event.SellTickets">
                      <span>{{$t("events.buy")}}</span>
                      <span class="glyphicon glyphicon-menu-right"></span>
                  </router-link>
                  <a v-bind:href="event.SellLink" v-if="event.SellLink" target="_blank">
                      <span>{{$t("events.buy")}}</span>
                      <span class="glyphicon glyphicon-menu-right"></span>
                  </a>
                  <span v-if="event.SoldOut">
                      <span>{{$t("events.buy")}}</span>
                      <span class="glyphicon glyphicon-menu-right"></span>
                  </span>
                  <span v-if="!event.SellTickets" @click="showInformation(event)">
                      <span>{{$t("events.info")}}</span>
                      <span class="glyphicon glyphicon-menu-right"></span>
                  </span>
                </span>
                <span class="small">{{getTicketPrice(event)}}</span>
                <span class="small" v-if="event.PlaceCards">({{$t("events.fixed-place")}})</span>
              </div>
            </div>
            <span class="additional-information" v-if="event.Comment" v-html="event.Comment"></span>
          </div>
        </div>
        <div id="overlay-info" class="animate-hide">
          <div v-if="event_for_info">
            <div class="title">Ruth - {{$t("events." + event_for_info.Type.replace(" ", "-"))}}</div>
            <div class="date">{{event_for_info.DateTime.format("dd, L")}}, {{event_for_info.DateTime.format("LT")}} {{$t("events.time-postfix")}}</div>
            <div class="row">
              <div class="column">
                <div class="subheader">{{$t("events.address")}}</div>
                <div class="location">{{event_for_info.Location}}</div>
                <div class="place">{{event_for_info.Address}}</div>
                <div class="city">{{event_for_info.PostalCode}} {{event_for_info.City}}</div>
                <div class="country">{{event_for_info.State}}<span v-if="event_for_info.State && event_for_info.Country">,</span> {{event_for_info.Country}}</div>

                <div class="subheader" v-if="event_for_info.SellLink">Tickets</div>
                <div class="tickets">{{getTicketPrice(event_for_info)}}</div>
              </div>
              <div class="column">
                <div class="information" v-if="event_for_info.Type === 'Das Konzert'">
                  <div class="subheader" v-html="$t('events.concert')"></div>
                  <div v-html="$t('events.concert-info')"></div>
                </div>
              </div>
            </div>
            <div class="info" v-html="event_for_info.InfoComment"></div>
            <span class="glyphicon glyphicon-remove icon-close" @click="hideInformation()"></span>
          </div>
        </div>

        <div class="form">
            <span v-html="$t('events.nothing-there')"></span><br>
            <span v-html="$t('events.newsletter-information')"></span>
            <form method="get" action="https://newsletter.kisi.org/">
                <input type="hidden" name="step" value="2">
                <input type="hidden" name="mode" value="ruth">
                <div class="inputs">
                    <input type="email" required name="mail" v-bind:placeholder="$t('events.email')">
                    <div class="ticket-button">
                        <input type="submit" v-bind:value="$t('events.register')">
                        <span class="glyphicon glyphicon-menu-right"></span>
                    </div>
                </div>
            </form>
       </div>
    </div>
</template>

<script>
import moment from "moment";
import config from "../../config";
import loader from "../GlobalSegments/Loader";
import eventInfo from "../Content/Performances"

export default {
  components: {
    loader
  },
  name: "events",
  data: function() {
    return {
      displayLoading: true,
      error: false,
      events: [],
      event_for_info: null
    };
  },
  mounted: function() {
    this.$http.get(config.event_url).then(
      response => {
        let events = response.body;
        if (typeof events === "object") {
          this.displayLoading = false;

          events = events.filter(event => !event.Hidden).sort(function(a, b) {
            return a.DateTime < b.DateTime ? -1 : 1;
          });

          for (let e = 0; e < events.length; e++) {
            events[e].DateTime = moment(events[e].DateTime.replace("Z", ""));
            events[e].DateSell = moment(events[e].DateSell.replace("Z", ""));

            if (eventInfo[events[e].ID]) {
              events[e].InfoComment = eventInfo[events[e].ID].InfoComment;
            }
          }

          this.events = events;
        }
      },
      errorMessage => {
        if (config.redirect) {
          window.location.href =
            "http://www.oeticket.com/tickets.html?fun=erdetail&affiliate=H65&doc=erdetaila&erid=1846649&xtor=AL-6071-[Linkgenerator]-[H65]";
        }
        this.displayLoading = false;
      }
    );
  },
  methods: {
    getTicketPrice: function(event) {
      if (event.SoldOut) {
        return this.$i18n.t("events.sold-out");
      } else if (!event.SellTickets) {
        return ""; //event.Price;
      } else if (event.TicketPrice) {
        let price = this.formatPrice("" + event.TicketPrice);
        return this.$i18n.t("events.starting-at") + " " + price + " €";
      } else {
        let euro = Math.floor(event.Price / 100);
        let cent = event.Price % 100;
        let price = cent !== 0 ? euro + "," + cent : euro + "";
        price = this.formatPrice(price);
        return this.$i18n.t("events.starting-at") + " " + price + " €";
      }
    },
    formatPrice: function(price) {
      price = price.replace(".", ",");
      let index = price.indexOf(",");
      if (index != -1 && index + 2 >= price.length) {
        return price + "0";
      }

      return price;
    },
    getLink: function(event) {
      if (event.DateSell.diff(moment(), "d", true) > 0) {
        return '/' + this.$i18n.locale.split('-')[0] + '/' + this.$t('header.tickets')  + '/' + event.ID;
      } else {
        return "/toolate";
      }
    },
    showInformation: function(event) {
      $("#overlay-info, #overlay-background").removeClass("animate-hide");
      $("body").addClass("overflow-hidden");
      this.event_for_info = event;
    },
    hideInformation: function() {
      $("#overlay-info, #overlay-background").addClass("animate-hide");
      $("body").removeClass("overflow-hidden");
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/var";

.event-container {
  font-family: $condensed_font;

  .filler {
    font-size: 20px;
  }

  .oeticket-info {
    max-width: 500px;
    display: inline-block;
    margin-bottom: 30px;
    margin-top: 0;
    padding: 0 10px;
  }

  .event {
    padding: 20px 0 25px 0;
    border-bottom: 1px solid $golden_color;
    font-size: 20px;

    @include media-small {
      padding: 20px;
    }

    @include media-phone {
      padding: 10px;
      font-size: 18px;
    }

    &.choose-place {
      padding-bottom: 5px;

      .inner-container {
        align-items: flex-start;
      }

      .small:last-of-type {
        padding-top: 0;
      }
    }

    &:first-of-type {
      border-top: 1px solid $golden_color;
    }

    .inner-container {
      display: flex;
      flex-direction: row;
    }

    .additional-information {
      color: $golden_color;
      font-weight: 400;
      font-size: 16px;

      a,
      a:hover,
      a:visited {
        color: inherit;
        text-decoration: underline;
      }
    }

    .column {
      display: flex;
      flex-direction: column;
      justify-content: center;

      &.information {
        flex: 1;
        flex-direction: row;
        align-items: flex-start;
      }
    }

    .ticket {
      @include media-phone {
        padding: 2px;
      }
    }

    .time {
      width: 220px;

      @include media-tablet {
        width: auto;
        font-size: 26px;
      }
    }

    .time span,
    .location .bold {
      @include media-tablet {
        font-weight: 700;
      }
    }

    .time,
    .musical,
    .information {
      @include media-tablet {
        display: block;
      }
    }

    .ticket,
    .location {
      @include media-tablet {
        flex-direction: column;
      }
    }

    .musical span,
    .location span {
      @include media-tablet {
        font-weight: 300;
      }

      @include media-phone {
        font-size: 16px;
      }
    }

    .time span,
    .location .bold {
      @include media-phone {
        font-size: 20px;
      }
    }

    .time .bold::after,
    .musical .bold::after {
      @include media-tablet {
        content: " - ";
      }
    }

    .musical {
      @include media-tablet {
        order: 1;
      }
    }

    .location {
      @include media-tablet {
        order: 2;
      }
    }

    .bold {
      font-weight: 700;
      font-size: 26px;
    }

    .extra-wrapper {
      top: -8px;
      position: relative;
      display: block;

      @include media-phone {
        top: -2px;
      }
    }

    .extra {
      font-size: 14px;
      background-color: $ticket_button_background_color;
      padding: 0 4px;
      display: inline;
    }

    .button {
      @include ticket_button;

      @include media-phone {
        height: 35px;
        font-size: 17px;
        padding: 0 7px;
        min-width: 120px;
      }

      &.sold-out {
        background-color: #8d8d8d;

        &,
        a {
          cursor: default;
        }

        &:hover {
          transform: scale(1);
        }
      }

      .glyphicon {
        @include media-phone {
          font-size: 15px;
        }
      }
    }

    .small {
      font-style: italic;
      font-size: 14px;
      padding-top: 4px;
      text-align: center;

      a {
        color: inherit;
        text-decoration: underline;
      }
    }
  }

  #overlay-info {
    background: $container_background_color;
    border-radius: 3px;
    width: 600px;
    height: 360px;
    margin-top: -180px;
    margin-left: -300px;
    padding: 16px;
    font-size: 18px;

    @include media-small {
      width: 100%;
      height: auto;
      top: 100px;
      left: 0;
      margin-top: 0;
      margin-left: 0;
    }

    .row {
      display: flex;

      .column {
        flex: 1 1 0
      }
    }

    .info {
      font-size: 16px;
    }

    .country {
      margin-bottom: 16px;
    }

    .title {
      font-weight: 700;
      font-size: 26px;
    }

    .date {
      font-size: 22px;
      margin-bottom: 16px;
    }

    .subheader {
      font-weight: 700;
      font-size: 20px;
    }
  }

  .form {
    text-align: center;
    margin-top: 36px;

    .inputs {
      margin-top: 24px;
      display: flex;
      justify-content: center;
    }

    .ticket-button {
        margin-left: 12px;
        @include ticket_button;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainSegments/Events.vue